import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  public getToken(): string {
    // return localStorage.getItem('token');
    return 'U0ZDVXNlcjpTRkNVc2VyMUAz';
  }

  logout(): Observable<HttpResponse<any>> {
    return this.http.post<any>(AppConfig.appsettings.apiRoot + '/logout', {}, { observe: 'response' });
  }
  // public isAuthenticated(): boolean {
  //   // get the token
  //   const token = this.getToken();
  //   // return a boolean reflecting 
  //   // whether or not the token is expired
  //   return tokenNotExpired(null, token);
  // }
}
